import type { DeepPartial } from '@luna/utils-ts';

import type { OwnFxTransfer } from './OwnFxTransfer';

export const CZ: DeepPartial<OwnFxTransfer> = {
    isCollectiveSigningInfoDisplayed: true,
};
